/* istanbul ignore file */
import { StorageInterface } from '../storage';
import { Meta } from './interfaces/Meta';

export class MetaClientService implements Meta {
  private keyPrefix = 'meta';
  public meta = { href: '' };

  constructor(private readonly sessionStorage: StorageInterface) {
    this.init();
  }

  private init() {
    if (!this.sessionStorage.get(this.keyPrefix)) {
      this.sessionStorage.set(this.keyPrefix, {
        href: window.location.href,
      });
    }

    const meta = this.sessionStorage.get(this.keyPrefix);

    if (!meta) {
      return;
    }

    this.meta = meta as { href: string };
  }

  getMeta() {
    return this.meta;
  }
}
